import { apiCall } from "./data";

// Package  Apis

export const getAllPackage = async(data)=>{
    return apiCall("api/packages", "GET");
}

export const getSinglePackage = async(id)=>{
    return apiCall(`api/packages/${id}`, "GET");
}

export const bookPackage  = async(data, headers)=>{
    return apiCall(`api/package-subscription`, "POST", data, headers );
}

export const getSelfBookingPackage  = async()=>{
    return apiCall(`api/package-subscription/user/self`, "GET", );
}

export const activePackageSubscription  = async()=>{
    return apiCall(`api/package-subscription/user/active`, "GET", );
}


// Booking Apis


export const getCourseSlot  = async(courseId, date)=>{
    return apiCall(`api/booking/check/slot?courseId=${courseId}&date=${date}`, "GET", );
}

export const getSelfBookiing  = async()=>{
    return apiCall(`api/booking/self/booking`, "GET", );
}

export const bookClass   = async(data, headers)=>{
    return apiCall(`api/booking/direct`, "POST", data, headers );
}
export const createPaymentOrder   = async(data)=>{
    return apiCall(`api/payment/create-payment`, "POST", data );
}

export const verifyPaymentOrder   = async(data)=>{
    return apiCall(`api/payment/payment-verify`, "POST", data );
}

export const createPackagePaymentOrder   = async(data)=>{
    return apiCall(`api/payment/package/create-payment`, "POST", data );
}
export const verifyPackagePaymentOrder   = async(data)=>{
    return apiCall(`api/payment/package/payment-verify`, "POST", data );
}

export const bookClassByPackage   = async(data, headers)=>{
    return apiCall(`api/booking/package-booking`, "POST", data, headers );
}

export const bookClassByWallet   = async(data, headers)=>{
    return apiCall(`api/booking/wallet-purchase`, "POST", data, headers );
}
export const addToWaitlist   = async(data)=>{
    return apiCall(`api/booking/waitlist/add`, "POST", data );
}

export const removeFromWaitlist   = async(data)=>{
    return apiCall(`api/booking/waitlist/remove`, "POST", data );
}

export const isUserInWaitlist   = async(courseId, date)=>{
    return apiCall(`api/booking/waitlist/status?courseId=${courseId}&date=${date}`, "GET");
}

export const BookingCancel   = async(id, headers)=>{
    return apiCall(`api/booking/user-cancel/${id}`, "PUT", {}, headers );
}
// Course Apis

export const getAllCourse = async(data)=>{
    return apiCall("api/yogaCourse", "GET");
}

export const getdaysCourse = async(data)=>{
    return apiCall("api/yogaCourse/courses/next-14-days", "GET");
}

export const getSingleClass  = async(id)=>{
    return apiCall(`api/yogaCourse/${id}`, "GET");
}


// User Apis

export const selfProfile  = async(data)=>{
    return apiCall(`api/user/self`, "GET",);
}



